module.exports = __webpack_public_path__ + "static/img/10.5a3c87a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/10.png
// module id = nXDJ
// module chunks = 0